import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { DontSanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
    standalone: true,
    selector: 'mono-common-callout',
    templateUrl: './callout.component.html',
    styleUrls: ['./callout.component.scss'],
    imports: [
      CommonModule,
      DontSanitizeHtmlPipe
    ]
})
export class CalloutComponent {

  public base = input.required<string>();
  public type = input.required<string>();
  public calloutText = input.required<string>();

  public animation = input<string>();
  public errorDescription = input<string>();
  public warningDescription = input<string>();
  public ariaLabel = input<string>('Extra page information');
  public paddingOrMarginAlteration = input<string>();
  public success = input<boolean>();
  public error = input<boolean>();
  public warning = input<boolean>();
  public positioning = input<string>();

}